import { forwardRef, Ref } from 'react';
import { FormProps, Form as AntForm, FormInstance } from 'antd';
import { DataTestIdProxy } from 'common/components/Utilities/DataTestIdProxy';
import { SWrapper } from './Form.style';
import { FormItem } from './FormItem';

export const InternalForm = forwardRef(
  (
    {
      dataTestId,
      rootClassName,
      ...restProps
    }: FormProps & {
      dataTestId?: string;
    },
    ref: Ref<FormInstance>,
  ) => (
    <DataTestIdProxy dataTestId={dataTestId}>
      <SWrapper>
        {/* @ts-ignore */}
        <AntForm
          layout="vertical"
          rootClassName={['custom-ant-form', rootClassName].join(' ')}
          {...restProps} ref={ref}
        />
      </SWrapper>
    </DataTestIdProxy>
  ),
);

export const Form = Object.assign(InternalForm, {
  Item: FormItem,
  useForm: AntForm.useForm,
  useFormInstance: AntForm.useFormInstance,
});
